// URL mapping for Turkish and English routes
export const routes = {
  tr: {
    premiumInterview: "/premium-canli-mulakat",
    standardInterview: "/standart-videolu-ai-mulakat",
    voiceInterview: "/sesli-ai-mulakat",
    textInterview: "/yazili-ai-mulakat",
    whatsappInterview: "/whatsapp-mulakat",
    phoneInterview: "/telefon-mulakat",
    interviewObserver: "/ai-mulakat-gozlemcisi",
    peerInterview: "/ekip-bazli-mulakat",
    cvScoring: "/cv-skorlama",
    assessments: "/degerlendirmeler",
    ats: "/aday-takip-sistemi",
    training: "/egitim",
    kvkk: "/kvkk",
    blog: "/ik-blogu",
    blogDetail: "/ik-blogu/:slug",
    career: "/kariyer",
    jobDetail: "/kariyer/:slug",
    contact: "/iletisim",
    faq: "/sss",
    terms: "/kullanim-kosullari",
    privacy: "/gizlilik-politikasi",
    cookies: "/cerez-politikasi",
    calendar: "/takvim",
    newsletter: "/bulten",
    applyCv: "/basvuru",
    peerEmployee: "/peer-degerlendirme",
    peerCandidate: "/peer-cevap",
    cvBuilder: "/cv-olusturucu",
  },
  en: {
    premiumInterview: "/premium-live-interview",
    standardInterview: "/standard-video-ai-interview",
    voiceInterview: "/voice-ai-interview",
    textInterview: "/text-ai-interview",
    whatsappInterview: "/whatsapp-interview",
    phoneInterview: "/phone-interview",
    interviewObserver: "/ai-interview-observer",
    peerInterview: "/peer-interview",
    cvScoring: "/cv-scoring",
    assessments: "/assessments",
    ats: "/ats",
    training: "/training",
    kvkk: "/gdpr",
    blog: "/blog",
    blogDetail: "/blog/:slug",
    career: "/career",
    jobDetail: "/career/:slug",
    contact: "/contact",
    faq: "/faq",
    terms: "/terms-of-use",
    privacy: "/privacy-policy",
    cookies: "/cookie-policy",
    calendar: "/calender",
    newsletter: "/newsletter",
    applyCv: "/apply",
    peerEmployee: "/peer-review",
    peerCandidate: "/peer-answer",
    cvBuilder: "/cv-builder",
  },
};

const normalizePathname = (pathname = "/") =>
  pathname.split("?")[0].split("#")[0];

const parsePattern = (pattern) => {
  const segmentNames = [];
  const escaped = pattern.replace(/:[^/]+/g, (segment) => {
    segmentNames.push(segment.slice(1));
    return "([^/]+)";
  });
  return {
    regex: new RegExp(`^${escaped}$`),
    segmentNames,
  };
};

export const getRouteMatchFromPath = (pathname) => {
  const cleanPath = normalizePathname(pathname);

  for (const language of ["tr", "en"]) {
    for (const [key, pattern] of Object.entries(routes[language])) {
      if (!pattern.includes(":")) {
        if (pattern === cleanPath) {
          return { key, language, params: {} };
        }
        continue;
      }

      const { regex, segmentNames } = parsePattern(pattern);
      const match = cleanPath.match(regex);
      if (!match) continue;

      const params = segmentNames.reduce((acc, name, index) => {
        acc[name] = decodeURIComponent(match[index + 1]);
        return acc;
      }, {});

      return { key, language, params };
    }
  }

  return null;
};

// Get route based on current language
export const getRoute = (routeKey, language = "tr", params = {}) => {
  const pathPattern =
    routes[language]?.[routeKey] || routes.tr[routeKey] || "/";
  return pathPattern.replace(/:([^/]+)/g, (_, key) => {
    const value = params[key];
    return value ? encodeURIComponent(String(value)) : "";
  });
};

// Get route key from pathname (for redirects)
export const getRouteKeyFromPath = (pathname) => {
  return getRouteMatchFromPath(pathname)?.key || null;
};
